export enum MeasurementUnit {
    GRAM = 'GRAM',
    PIECE = 'PIECE',
}
